import {useCallback} from 'react';
import updateUserDoc from '../../api/user/updateUserDoc';
import {firebaseAuth} from '../../config/firebase';
import {useFunctionRun} from '../helper/function/useFunctionRun';

export default function useSetSoundVolume() {
  const setSoundVolumeFn = useCallback(async (volume: number): Promise<void> => {
    const uid = firebaseAuth.currentUser?.uid;
    if (!uid) throw new Error('Not authenticated');
    await updateUserDoc(uid, {soundVolume: volume});
  }, []);

  const {loading, error, refetch} = useFunctionRun(setSoundVolumeFn, {
    skipLoadOnMount: true,
  });

  return {
    setSoundVolume: refetch,
    loading,
    error,
  };
}
